<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Modelli SMS</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <button class="btn btn-white vertical align-items-center" routerLink="nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper">
        <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"> </app-pagination>
        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
          <form class="table-row-container row first-row filter" [formGroup]="_smsTemplateForm" (ngSubmit)="filter()"
          *ngIf="_smsTemplateForm">

            <div class="item data-col-10 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('SmsTemplate.id')">
                <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.id')"></i>
                ID
              </h4>
              <span class="data">
                <input type="number" formControlName="SmsTemplate.id" min="1000" max="10000" >
              </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('SmsTemplate.temp_type')">
                <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.temp_type')"></i>
                Tipo
              </h4>
              <span class="data">
                <input type="text" formControlName="SmsTemplate.temp_type" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                Partner
              </h4>
              <span class="data">
                <input type="text" formControlName="Partner.businessName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('SmsTemplate.description')">
                <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.description')"></i>
                Descrizione
              </h4>
              <span class="data">
                <input type="text" formControlName="SmsTemplate.description" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-5 hideOnPhoneView">
                <h4 class="title">Azioni</h4>
                <span class="data saifu">
                  <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
                    <i class="fas fa-search"></i>
                  </button>
                  <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
                    <i class="fas fa-undo"></i>
                  </button>
                </span>
            </div>
          </form>

          <div class="table-row-container row" *ngFor="let adminSmsTemplate of adminSmsTemplates">
            <div class="item data-col-10">
              <h4 class="title" [ngClass]="orderIcon('SmsTemplate.id')">
                <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.id')"></i>
                ID
              </h4>
              <div class="data data-id">
                <div>{{adminSmsTemplate.id}}</div>
              </div>
            </div>

            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('SmsTemplate.temp_type')">
                <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.temp_type')"></i>
                Tipo
              </h4>
              <div class="data">
                <div>{{adminSmsTemplate.temp_type}}</div>
              </div>
            </div>


            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                Partner
              </h4>
              <div class="data">
                <div>{{adminSmsTemplate?.partner?.businessName || "Admin"}}</div>
              </div>
            </div>

            <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('SmsTemplate.description')">
                <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.description')"></i>
                Descrizione
              </h4>
              <div class="data">
                <div>{{adminSmsTemplate.description}}</div>
              </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title"></h4>
                <span class="data saifu">
                  <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top" [routerLink]="['/admin/smstemplates', adminSmsTemplate.id, 'edit']">MODIFICA</button>
                  <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(adminSmsTemplate.id)">
                    Elimina<i class="ml-10 far fa-trash-alt"></i>
                  </button>
                </span>
            </div>
          </div>
        </div>
    </section>

  </div>
</section>

<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Modelli SMS</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button routerLink="nuovo" class="btn btn-white vertical align-items-center">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>
<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage">
    </app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
      <form class="table-row-container row first-row filter" [formGroup]="_smsTemplateForm" (ngSubmit)="filter()"
      *ngIf="_smsTemplateForm">

        <div class="item data-col-10 hideOnPhoneView">
          <h4 class="title" (click)="navigateOrder('SmsTemplate.id')">
            <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.id')"></i>
            ID
          </h4>
          <span class="data">
            <input type="number" formControlName="SmsTemplate.id" min="1000" max="10000" >
          </span>
        </div>

        <div class="item data-col-20 hideOnPhoneView">
          <h4 class="title" (click)="navigateOrder('SmsTemplate.temp_type')">
            <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.temp_type')"></i>
            Tipo
          </h4>
          <span class="data">
            <input type="text" formControlName="SmsTemplate.temp_type" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
          </span>
        </div>

        <div class="item data-col-20 hideOnPhoneView">
          <h4 class="title" (click)="navigateOrder('Partner.businessName')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
            Partner
          </h4>
          <span class="data">
            <input type="text" formControlName="Partner.businessName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
          </span>
        </div>

        <div class="item data-col-20 hideOnPhoneView">
          <h4 class="title" (click)="navigateOrder('SmsTemplate.description')">
            <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.description')"></i>
            Descrizione
          </h4>
          <span class="data">
            <input type="text" formControlName="SmsTemplate.description" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
          </span>
        </div>

        <div class="item nowrap">
          <h4 class="title hide-on-mobile">AZIONI</h4>
          <span class="data-row-left btn-container">
            <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
              RICERCA <i class="fas fa-search"></i>
            </button>
              <br/>
            <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter()">
              RESET <i class="fas fa-times-circle"></i>
            </button>
          </span>
        </div>

      </form>
      <div class="table-row-container row" *ngFor="let adminSmsTemplate of adminSmsTemplates">
        <div class="item data-col-10">
          <h4 class="title" [ngClass]="orderIcon('SmsTemplate.id')">
            <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.id')"></i>
            ID
          </h4>
          <div class="data data-id">
            <div>{{adminSmsTemplate.id}}</div>
          </div>
        </div>

        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('SmsTemplate.temp_type')">
            <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.temp_type')"></i>
            Tipo
          </h4>
          <div class="data">
            <div>{{adminSmsTemplate.temp_type}}</div>
          </div>
        </div>


        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('Partner.businessName')">
            <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
            Partner
          </h4>
          <div class="data">
            <div>{{adminSmsTemplate?.partner?.businessName || "Admin"}}</div>
          </div>
        </div>

        <div class="item data-col-10">
          <h4 class="title" (click)="navigateOrder('SmsTemplate.description')">
            <i class="sort-icon fas" [ngClass]="orderIcon('SmsTemplate.description')"></i>
            Descrizione
          </h4>
          <div class="data">
            <div>{{adminSmsTemplate.description}}</div>
          </div>
        </div>

        <div class="item nowrap">
          <span class="data-row-left btn-container">
            <button class="btn vertical align-items-center" [routerLink]="['/admin/smstemplates', adminSmsTemplate.id, 'edit']">MODIFICA</button>
            <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(adminSmsTemplate.id)">
              Elimina<i class="ml-10 far fa-trash-alt"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
</section>
-->
